import React, { useEffect, useState } from "react";
import { getAppealDeadlineRemaining } from "../../utils/appealHrDeadline";
import "./AppealDeadlineClock.css";

function pad(value) {
  return String(value).padStart(2, "0");
}

const UNITS = [
  { key: "days", label: "يوم" },
  { key: "hours", label: "ساعة" },
  { key: "minutes", label: "دقيقة" },
  { key: "seconds", label: "ثانية" },
];

export default function AppealDeadlineClock({ dueAt, compact = false }) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const due = new Date(dueAt).getTime();
    if (!dueAt || Number.isNaN(due) || Date.now() >= due) return undefined;
    const id = setInterval(() => {
      const next = new Date();
      setNow(next);
      if (next.getTime() >= due) clearInterval(id);
    }, 1000);
    return () => clearInterval(id);
  }, [dueAt]);

  const remaining = getAppealDeadlineRemaining(dueAt, now);
  if (!remaining) return null;

  if (remaining.expired) {
    return (
      <div
        className={`appeal-clock is-expired${compact ? " is-compact" : ""}`}
        role="timer"
      >
        <span className="appeal-clock-expired">انتهت مهلة التظلم</span>
      </div>
    );
  }

  return (
    <div
      className={`appeal-clock${compact ? " is-compact" : ""}`}
      role="timer"
      aria-label="الوقت المتبقي على مهلة التظلم"
    >
      <span className="appeal-clock-caption">فاضل على مهلة التظلم</span>
      <div className="appeal-clock-units">
        {UNITS.map((unit) => (
          <div key={unit.key} className="appeal-clock-unit">
            <span className="appeal-clock-value">{pad(remaining[unit.key])}</span>
            <span className="appeal-clock-label">{unit.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
